import FbPixel from './fbq';

export const VIRTUAL_PAGE_VIEW_EVENT = 'bsfood_virtual_page_view';

interface IVirtualPageView {
  pathname: string;
  search: string;
  title: string;
}

/**
 * Notifies the tracking integrations that were injected server side about a SPA navigation.
 *
 * Both destinations are optional at runtime: the Facebook wrapper is a no-op without `window.fbq`
 * and the Google Tag Manager push only happens once the container created `window.dataLayer`.
 */
export const trackVirtualPageView = ({ pathname, search, title }: IVirtualPageView): void => {
  FbPixel.event.pageView();

  window.dataLayer?.push({
    event: VIRTUAL_PAGE_VIEW_EVENT,
    page_location: window.location.href,
    page_path: `${pathname}${search}`,
    page_title: title,
  });
};

export default trackVirtualPageView;
